// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false";

export const AUTH_APIs = {
  // User Login
  userLogin: async (args = {}) => {
    let apiUrl = "/au/v1/306E7421V77191BL";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8001/au/v1/306E7421V77191BL";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      PRODUCTION === "false"
    );
    console.log(response);
    return response;
  },

  // Check Login
  checklogin: async (args = {}) => {
    let apiUrl = "/au/v1/911V6888F35172KR";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8001/au/v1/911V6888F35172KR";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      PRODUCTION === "false"
    );
    return response;
  },

  // Change Password => POST
  changePassword: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/au/v1/281V7032G95892VS",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // User Session End
  logout: async (args = {}) => {
    let apiUrl = "/au/v1/227Z6190M33745TH";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8001/au/v1/227Z6190M33745TH";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      {},
      false,
      PRODUCTION === "false"
    );
    return response;
  },

  // updateFcmToken
  updateFcmToken: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/au/v1/357Q3245A12214LS",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  ///
  fileUpload: async (args = {}) => {
    let apiUrl = "/au/v1/352G4430K46192JU";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8001/au/v1/352G4430K46192JU";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      PRODUCTION === "false"
    );
    return response;
  },

  getFile: async (args = {}) => {
    let apiUrl = "/au/v1/149Z7769V62163UT";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8001/au/v1/149Z7769V62163UT";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      PRODUCTION === "false"
    );
    return response;
  },
};
